import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface GetICSBulkOrderListInterface {
  orderNo?: string
}

export const GetICSBulkOrderList = () => {
  const mutate = useMutation(({ orderNo }: GetICSBulkOrderListInterface) => {
    return postAPI(`/ICSBulkCOnsignment/ICSBulkOrderList`, { orderNo: orderNo })
  })

  return mutate
}

export default GetICSBulkOrderList
